/** angular */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
/** end angular */

/** services */
import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';
/** end services */

/** models */
import { BydModel } from '@sixense/byd-core-service';
import { DsPinComment } from '../models/ds-pin-comment';
/** end models */

@Injectable({
  providedIn: 'root',
})
export class DsPinsCommentsService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService
   */
  public path: string;

  /**
   * Get all the pin comments.
   *
   * @param projectId Current project ID
   * @param pinId ID of the pin
   * @returns Observable<BydModel<DsPinComment>>
   */
  public getPinComments(projectId: number, pinId: number): Observable<BydModel<DsPinComment>> {
    this.path = `/v1/projects/${projectId}/pins/${pinId}/comments`;
    return this.getModels<DsPinComment>();
  }

  /**
   * Add a new comment to the current pin.
   *
   * @param projectId The current project ID
   * @param pinId The current pin ID
   * @param comment Value of the comment to add
   * @param photo Comment photo
   * @returns Observable<boolean>
   */
  public addPinComment(projectId: number, pinId: number, comment: string, photo?: Blob | null): Observable<boolean> {
    // Sets current timestamp in seconds for the backend.
    const currentTimestamp = (new Date().getTime() / 1000).toString();
    const formData = new FormData();
    formData.append('comment', comment);
    formData.append('date', currentTimestamp);
    if (photo) formData.append('file', photo);
    const headers = this.bydConfigService.headers.delete('Content-Type');
    this.path = `/v1/dspin/projects/${projectId}/pins/${pinId}/comment`;
    return this.post<boolean>({ body: formData, headers });
  }

  /**
   * Create DsPin instance.
   *
   * @param  jsonObject The flat json object.
   * @returns an `DsPin` instance.
   */
  // TODO:  Set up the correct type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public createNewInstance(jsonObject: any): DsPinComment {
    return new DsPinComment(jsonObject);
  }
}
